import * as React from 'react';
import { ReactNode } from 'react';

export enum InputType {
  Text = 'text',
  Number = 'number',
  Email = 'email',
  Password = 'password',
  Money = 'money',
}

export enum InputBackground {
  White = 'white',
  Gray = '#f6f6f6',
}

export interface InputProps {
  type?: InputType;
  autoFocus?: boolean;
  name: string;
  value?: string;
  disabled?: boolean;
  blue?: boolean;
  small?: boolean;
  focus?: boolean;
  pattern?: string;
  maxLength?: number;
  autoComplete?: string;
  enableAutoComplete?: boolean;
  placeholder?: string;
  animatedLabel?: string;
  className?: string;
  centeredText?: boolean;
  dataAt?: string;
  dataTestId?: string;
  label?: string | React.ReactChild;
  error?: string;
  warning?: string;
  background?: InputBackground;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit?: () => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  innerRef?: React.RefObject<HTMLInputElement>;
  onKeyEnter?: () => void;
  toggleFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isAnimated?: boolean;
  isSecuredInput?: boolean;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  initErrorSpacing?: boolean;
  initWarningSpacing?: boolean;
  id?: string;
  inputMode?: React.HtmlHTMLAttributes<HTMLInputElement>['inputMode'];
  button?: ReactNode;
  required?: boolean;
  hidePlaceholderAsTitle?: boolean;
}
